import { gql } from '@apollo/client';

export const fetchDimensions = gql`
    query getDimensionList($featureName: String!) {
        getDimensionList(featureName: $featureName) {
            dimensionName
            dimensionReference
        }
    }
`;

export const getAttributeTypes = gql`
    query getAttributeTypes($dimension: SamyaString!, $hierarchy: SamyaString!, $featureName: String!) {
        getAttributeTypes(dimension: $dimension, hierarchy: $hierarchy, featureName: $featureName) {
            isAttribute
            name
            hierarchy
        }
    }
`;
export const getAttributeNames = gql`
    query getAttributeNames(
        $dimension: SamyaString!
        $isAttribute: Boolean!
        $attributeType: SamyaString!
        $searchKeyword: SamyaString!
        $filters: JSONString!
        $limit: Int!
        $offset: Int!
        $rbacFilters: JSONString!
        $featureName: String
    ) {
        getAttributeNames(
            dimension: $dimension
            isAttribute: $isAttribute
            attributeType: $attributeType
            searchKeyword: $searchKeyword
            filters: $filters
            limit: $limit
            offset: $offset
            rbacFilters: $rbacFilters
            featureName: $featureName
        ) {
            data {
                dimension
                isAttribute
                isActive
                attributeType
                attributeDesc
                attributeExId
                count
            }
            meta {
                count
                isActiveCount
            }
        }
    }
`;
export const applyFilterMutation = gql`
    mutation ApplyFilter(
        $jsonstring_dim1: JSONString
        $jsonstring_dim2: JSONString
        $jsonstring_dim3: JSONString
        $jsonstring_dim4: JSONString
        $featureName: String
    ) {
        dim1: applyFilter(dimension: "dim1", data: $jsonstring_dim1, featureName: $featureName) {
            ids
        }
        dim2: applyFilter(dimension: "dim2", data: $jsonstring_dim2, featureName: $featureName) {
            ids
        }
        dim3: applyFilter(dimension: "dim3", data: $jsonstring_dim3, featureName: $featureName) {
            ids
        }
        dim4: applyFilter(dimension: "dim4", data: $jsonstring_dim4, featureName: $featureName) {
            ids
        }
    }
`;

export const applyFilterMutationWithError = gql`
    mutation ApplyFilter(
        $jsonstring_dim1: JSONString
        $jsonstring_dim2: JSONString
        $jsonstring_dim3: JSONString
        $jsonstring_dim4: JSONString
        $featureName: String
    ) {
        dim1: applyFilter(dimension: "dim1", data: $jsonstring_dim1, featureName: $featureName) {
            ids
            errorDesc
        }
        dim2: applyFilter(dimension: "dim2", data: $jsonstring_dim2, featureName: $featureName) {
            ids
            errorDesc
        }
        dim3: applyFilter(dimension: "dim3", data: $jsonstring_dim3, featureName: $featureName) {
            ids
            errorDesc
        }
        dim4: applyFilter(dimension: "dim4", data: $jsonstring_dim4, featureName: $featureName) {
            ids
            errorDesc
        }
    }
`;

export const getDefinedTimePeriods = gql`
    {
        getDefinedTimePeriods {
            timeBucket
            startTimestamp
            endTimestamp
        }
    }
`;

export const getGlobalTimePeriods = gql`
    query getGlobalTimePeriods($featureName: String) {
        getGlobalTimePeriods(featureName: $featureName) {
            timePeriod
            startTimestamp
            endTimestamp
        }
    }
`;

//PRESET FILTER
export const savePresetFilter = gql`
    mutation createPresetFilter(
        $userEmail: String!
        $presetFilterName: String!
        $presetFilterJson: JSONString!
        $defaultFlag: Boolean!
    ) {
        createPresetFilter(
            userEmail: $userEmail
            presetFilterName: $presetFilterName
            presetFilterJson: $presetFilterJson
            defaultFlag: $defaultFlag
        ) {
            operationStatus
            __typename
        }
    }
`;

export const getPresetList = gql`
    query getUserPresetsList($userId: String!) {
        getUserPresetsList(userId: $userId) {
            presetFilterName
            defaultFlag
        }
    }
`;

export const getPreset = gql`
    mutation fetchUserPreset($userEmail: String!, $presetFilterName: String, $defaultFlag: Boolean!) {
        fetchUserPreset(userEmail: $userEmail, presetFilterName: $presetFilterName, defaultFlag: $defaultFlag) {
            presetFilterName
            presetFilter
            defaultFlag
            __typename
        }
    }
`;
